export default "__VITE_PUBLIC_ASSET__94f0895c__"